import { IssueModel } from './betting.model';

export class CurrIssue {
    CurrentIssueNo: string;
    PreviewIssueNo: string;
    RemainTime: number;
    Issue: IssueModel;
}


// WEBPACK FOOTER //
// ./src/models/bettingorder.dto.ts